import { FC } from 'react'

import { ISvgClass } from '../interface'

const CopyingIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M10 18C9.45 18 8.97933 17.8043 8.588 17.413C8.196 17.021 8 16.55 8 16V4C8 3.45 8.196 2.979 8.588 2.587C8.97933 2.19567 9.45 2 10 2H19C19.55 2 20.021 2.19567 20.413 2.587C20.8043 2.979 21 3.45 21 4V16C21 16.55 20.8043 17.021 20.413 17.413C20.021 17.8043 19.55 18 19 18H10ZM10 16H19V4H10V16ZM6 22C5.45 22 4.979 21.8043 4.587 21.413C4.19567 21.021 4 20.55 4 20V7C4 6.71667 4.096 6.479 4.288 6.287C4.47933 6.09567 4.71667 6 5 6C5.28333 6 5.521 6.09567 5.713 6.287C5.90433 6.479 6 6.71667 6 7V20H16C16.2833 20 16.521 20.096 16.713 20.288C16.9043 20.4793 17 20.7167 17 21C17 21.2833 16.9043 21.5207 16.713 21.712C16.521 21.904 16.2833 22 16 22H6Z"
        fill="inherit"
      />
    </svg>
  )
}

export default CopyingIcon
